import React, { useEffect, useState } from "react";
import { getGatewayExperience, readGatewayPresentation } from "./gatewayExperienceRegistry";

function useCandidate(candidates) {
  const [index, setIndex] = useState(0);
  useEffect(() => setIndex(0), [candidates.join("|")]);
  return [candidates[index], () => setIndex((current) => Math.min(current + 1, candidates.length - 1))];
}

export default function GatewayScene({ open, scene = "login" }) {
  const experience = getGatewayExperience(scene, readGatewayPresentation());
  const [desktop, advanceDesktop] = useCandidate(experience.desktopCandidates);
  const [mobile, advanceMobile] = useCandidate(experience.mobileCandidates);
  return (
    <div className={`gatewayScene${open ? " gatewayScene--open" : ""}`} aria-hidden="true">
      <picture>
        <source media="(max-width: 700px)" srcSet={mobile} onError={advanceMobile} />
        <img src={desktop} onError={advanceDesktop} alt="" decoding="async" fetchPriority="high" />
      </picture>
      <div className="gatewayScene__wash" />
      <div className="gatewayScene__grain" />
    </div>
  );
}
